export class StoreHours {
    storeGuid: string;
    effectiveDate: Date;
    expiryDate: Date;
    effectiveHours: string | Uint8Array;

    toString() {
        return `${this.storeGuid}: ${this.effectiveHours}`;
    }
}